"use client"
import { Button, Menu, MenuDropdown, MenuLabel, MenuTarget } from "@mantine/core"
import type { TLoginUserData } from "@/schemas/user.schema"

import { MenuItemInstallMobileAppButton } from "./components/MenuItemInstallMobileAppButton"
import { observer } from "@legendapp/state/react"
import { syncStore$ } from "@/stores/sync.v2.store"
import { UserProfileImageWithUserStatus } from "./components/UserProfileImageWithUserStatus"
import { MenuSectionDJUI } from "./components/MenuSectionDJUI"
import { MenuLogoutSection } from "./components/MenuLogoutSection"
import classes from "./HeaderButtonProfile.module.css"
import { MenuAdminSection } from "./components/MenuAdminSection/MenuAdminSection"
import { MenuExtraSection } from "./components/MenuExtraSection"

const BASE_TEST_ID = "menu-show-profile-"

export const HeaderButtonProfile = observer(function HeaderButtonProfile({ userData }: { userData?: TLoginUserData }) {
  const syncUserFullName = syncStore$.userStatus?.fullName.get()
  const userFullName = syncUserFullName || userData?.user.fullName || ""
  return (
    <Menu width={200} position="bottom-end" withArrow arrowPosition="center" offset={3}>
      <MenuTarget>
        <Button data-testid={`${BASE_TEST_ID}btn-toggle-menu`} aria-label="Profile" className={classes.button} pl="sm" pr="xs" rightSection={<UserProfileImageWithUserStatus userData={userData} />}>
          {userFullName}
        </Button>
      </MenuTarget>
      <MenuDropdown style={{ borderRadius: "var(--mantine-radius-lg)", boxShadow: "var(--mantine-shadow-lg)" }}>
        <MenuSectionDJUI />
        {/* <MenuTrialStatusSection /> */}
        <MenuLabel>Install</MenuLabel>
        {/* <MenuItemInstallExtensionButton
          id={userData.cluster.chromeExtensionWebstoreId}
        /> */}
        <MenuItemInstallMobileAppButton platform="ios" />
        {/* <MenuLabel>Other Options</MenuLabel> */}
        {/* <MenuItemUserSettingsButton /> */}
        {/* <MenuItemColorSchemeToggle /> */}
        <MenuAdminSection />
        <MenuExtraSection />
        <MenuLogoutSection />
      </MenuDropdown>
    </Menu>
  )
})
